import { useState, useEffect } from "react";
import { getBase64, getRessalva, getTextFile } from "../../helpers/functionsHelps";
import UploadCloud from "../../assets/svg/XMLModal/upload-cloud.svg";
import FileText from "../../assets/svg/file-text.svg"
import X from "../../assets/svg/x.svg"
import { useApi } from '../../hooks/useApi'
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal);

export default function RessalvaModal({ setRessalvaModal, ressalvaItem, tableItems }) {

    const [itemMais, setItemMais] = useState(false);
    const [itemMenos, setItemMenos] = useState(false);
    const [itemAvariado, setItemAvariado] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [errorMsg, setMsgError] = useState('');

    const api = useApi();

    useEffect(() => {

        MySwal.fire({
            icon: 'info',
            title: 'Ressalva de Itens',
            text: 'Para saber mais sobre a ressalva, clique em cima da mesma.',
            confirmButtonColor: '#00948b'
        });

    }, []);

    const handleClickRessalva = (ressalva) => {
        
        let texto = '';
        let titulo = '';
        if(ressalva == 1) {
            titulo += "ITENS A MAIS"
            texto += "<span>Essa ressalva informa que durante o processo de conferencia identificamos que vieram unidades a MAIS do item informado, divergindo do que está sendo informado na Nota Fiscal. <br/><br/> Para que possamos ter a correção do estoque físico presente no depósito precisamos que anexem o XML da Nota Fiscal complementar do item, nas quantidades informadas acima.</span>"
        }
        if(ressalva == 2) {
            titulo += "ITENS A MENOS"
            texto += "<span>Essa ressalva informa que durante o processo de conferencia identificamos que vieram unidades a MENOS do item informado, divergindo do que está sendo informado na Nota Fiscal. <br/><br/> Para que possamos ter a correção do estoque físico presente no depósito precisamos que anexem o XML da Nota Fiscal de Devolução do item, nas quantidades informadas acima.</span>"
        }
        if(ressalva == 3) {
            titulo += "ITENS AVARIADOS"
            texto += "<span>Essa ressalva informa que durante o processo de conferencia identificamos que vieram unidades AVARIADAS do item do que está sendo informado. <br/><br/> Para que possamos ter a correção do estoque físico presente no depósito precisamos que anexem o XML da Nota Fiscal de Devolução do item, nas quantidades informadas acima.</span>"
        }
        if(ressalva == 4) {
            titulo += "ITENS SEM IDENTIFICAÇÃO"
            texto += "<span>Essa ressalva informa que os itens listados vieram sem identificação, uma identificação com código de barras é obrigatória para entrada dos produtos no armazém, isso evita erros no processo de separação e facilita a localização do item. <br/><br/>Para que esse processo seja feito será gerada uma cobrança por unidade identificada que será cobrado na sua próxima cobrança do sazonal. </span>"
        }
        
        MySwal.fire({
            icon: 'info',
            title: titulo,
            html: texto,
            confirmButtonColor: '#00948b'
        });
    };  
    
    useEffect(() => {
        ressalvaItem.entradaItens.map((item, index) => {
            
            if(item.tipoRessalva == 1) {
                setItemMais(true);
            }

            if(item.tipoRessalva == 2) {
                setItemMenos(true);
            }

            if(item.tipoRessalva == 3) {
                setItemAvariado(true);
            }
        });

    }, []);

    const [fileItemMais, setFileItemMais] = useState('')
    const [fileNameItemMais, setFileNameItemMais] = useState('')

    const onFileDropItemMais = async (e) => {
        if(e.target.files.length > 0) {
            const newFile = e.target.files[0]
            if (newFile) {

                let base = await getTextFile(newFile)
                setFileItemMais(base);

                let nome = newFile.name;
                let resumo = '';
                if (nome.length > 15) {
                    resumo = nome.slice(0, 5);
                    resumo += '...' + nome.slice((nome.length - 10), nome.length);
                    setFileNameItemMais(resumo);
                } else {
                    setFileNameItemMais(nome);
                }
            }
        }
    }

    const handleDeleteFileMais = () => {
        setFileNameItemMais('');
        setFileItemMais('');
    }

    const [fileItemMenos, setFileItemMenos] = useState('')
    const [fileNameItemMenos, setFileNameItemMenos] = useState('')

    const onFileDropItemMenos = async (e) => {
        if(e.target.files.length > 0) {
            const newFile = e.target.files[0]
            if (newFile) {

                let base = await getTextFile(newFile)
                setFileItemMenos(base);
                
                let nome = newFile.name;
                let resumo = '';
                if (nome.length > 15) {
                    resumo = nome.slice(0, 5);
                    resumo += '...' + nome.slice((nome.length - 10), nome.length);
                    setFileNameItemMenos(resumo);
                } else {
                    setFileNameItemMenos(nome);
                }
            }
        }
    }

    const handleDeleteFileMenos = () => {
        setFileNameItemMenos('');
        setFileItemMenos('');
    }

    const [fileItemAvariado, setFileItemAvariado] = useState('')
    const [fileNameAvariado, setFileNameItemAvariado] = useState('')

    const onFileDropItemAvariado = async (e) => {
        if(e.target.files.length > 0) {
            const newFile = e.target.files[0]
            if (newFile) {

                let base = await getTextFile(newFile)
                setFileItemAvariado(base);
                
                let nome = newFile.name;
                let resumo = '';
                if (nome.length > 15) {
                    resumo = nome.slice(0, 5);
                    resumo += '...' + nome.slice((nome.length - 10), nome.length);
                    setFileNameItemAvariado(resumo);
                } else {
                    setFileNameItemAvariado(nome);
                }
            }
        }
    }

    const handleDeleteFileAvariado = () => {
        setFileNameItemAvariado('');
        setFileItemAvariado('');
    }

    const handleClickSave = async () => {

        
        setError(false);
        setLoading(true);

        if(itemMais == true) {
            if(fileItemMais == '') {
                setError(true);
                setMsgError('Necessário anexar XML da Ressalva Itens a Mais.')
                setLoading(false);
                return;
            }
        }

        if(itemMenos == true) {
            if(fileItemMenos == '') {
                setError(true);
                setMsgError('Necessário anexar XML da Ressalva Itens a Menos.')
                setLoading(false);
                return;
            }
        }

        if(itemAvariado == true) {
            if(fileItemAvariado == '') {
                setError(true);
                setMsgError('Necessário anexar XML da Ressalva Itens Avariados.')
                setLoading(false);
                return;
            }
        }

        for (let i = 0; i < ressalvaItem.entradaItens.length; i++) {
            let item = ressalvaItem.entradaItens[i];

            if (item.ressalva == true) {
                if (item.tipoRessalva == 1) {
                    item.xmlCCe = fileItemMais;
                }

                if (item.tipoRessalva == 2) {
                    item.xmlCCe = fileItemMenos;
                }

                if (item.tipoRessalva == 3) {
                    item.xmlCCe = fileItemAvariado;
                }
            }
        }

        let fornecedor = {
            nome: ressalvaItem.nomeFornecedor,
            blingId: ressalvaItem.idFabricante
        }

        let data = {
            entrada: ressalvaItem,
            fornecedor,
            produtos: ressalvaItem.entradaItens
        }

        try {
            await api.gravarEntrada(data);
            setRessalvaModal(null)
        } 
        catch (err) {
            setRessalvaModal(null)
            console.log(err);
        } 
        finally {
            setLoading(false);
        }
        
    };

    return (
        <div className="flex flex-col h-[95%] justify-center w-[85%] xl:w-[70%] mx-auto rounded-2xl px-5 bg-white drop-shadow-2xl">
            {/* Close button */}
            <span
                className="absolute -top-4 -right-4 bg-white drop-shadow-xl px-3 py-2.5 rounded-md text-soulog-900 font-bold cursor-pointer"
                onClick={() => setRessalvaModal(null)}
            >
                X
            </span>

            {/* Table */}
            <div className="mt-5 mb-5 w-full">
                <span className="text-black font-semibold text-xl">Ressalvas do Item</span>
            </div>
                
            <div className="overflow-x-auto">
                <table className="w-full text-xs text-left">
                    <thead className="text-xs text-white uppercase bg-soulog-900">
                        <tr>
                            <th scope="col" className="py-2 px-12">
                                SKU
                            </th>
                            <th scope="col" className="py-2 px-6">
                                Descrição
                            </th>
                            <th scope="col" className="py-2 px-6">
                                Ressalva
                            </th>
                            <th scope="col" className="py-2 px-6">
                                Quantidade
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {ressalvaItem.entradaItens.filter(x => x.ressalva == true).map((item, index) => (
                            <tr key={index} className="bg-white border-b-2 border-gray-200">
                                <td className="py-2 px-12">
                                    {item.codigoProdutoBling}
                                </td>
                                <td className="py-2 px-6 uppercase">
                                    {item.descricaoProduto}
                                </td>
                                
                                    <td className="py-3 px-6 cursor-pointer" onClick={() => handleClickRessalva(item.tipoRessalva)}>
                                        <Tippy content="Clique aqui para saber mais." arrow={true}>
                                            {getRessalva(item.tipoRessalva)}
                                        </Tippy>
                                    </td>
                                
                                <td className="py-2 px-6">
                                    {item.qtdeRessalva}
                                </td>
                            </tr>
                        ))} 
                    </tbody>
                </table>
            </div>

            { true &&
                <div className="flex flex-row justify-around">
                    <> 
                        {itemMais && 
                            <div className="flex flex-row justify-center items-center my-3">
                                <div className="flex flex-col border-[2px] text-center justify-center items-center border-soulog-900 rounded-md w-52 h-42">
                                    <p className="font-semibold mt-2">XML Ressalva <br/>Itens a Mais</p>
                                    
                                    {!fileItemMais &&
                                        <button className="relative border-[2px] w-48 border-soulog-900 text-soulog-900 text-sm font-semibold rounded-md px-4 py-2 mt-8 mb-2">
                                            <input type="file" accept="application/xml" className="absolute w-full h-full cursor-pointer top-0 left-0 opacity-0" value="" onChange={onFileDropItemMais}/>
                                            Selecionar Arquivo
                                        </button>
                                    }

                                    {fileItemMais &&
                                        <div className="flex flex-row border-[2px] text-center w-48 justify-between items-center border-soulog-900 text-soulog-900 text-sm font-semibold rounded-md mt-8 mb-2">
                                            <img src={FileText} alt="File Icon" className="my-2 w-6"/>
                                            <p className="font-bold text-xs">{fileNameItemMais}</p>
                                            <button className="relative top-0 right-0" onClick={handleDeleteFileMais}>
                                                <img src={X} alt="Close Icon" className="my-2 mr-2 w-4 rounded-full border-black border-solid border-2 "/>
                                            </button>
                                        </div>
                                    }

                                </div>
                            </div>
                        }

                        {itemMenos && 
                            <div className="flex flex-row justify-center items-center my-3">
                                <div className="flex flex-col border-[2px] text-center justify-center items-center border-soulog-900 rounded-md w-64 h-42">
                                    <p className="font-semibold mt-2">XML Ressalva <br/>Itens a Menos</p>
                                    
                                    {!fileItemMenos &&
                                        <button className="relative border-[2px] w-48 border-soulog-900 text-soulog-900 text-sm font-semibold rounded-md px-4 py-2 mt-8 mb-2">
                                            <input type="file" accept="application/xml" className="absolute w-full h-full cursor-pointer top-0 left-0 opacity-0" value="" onChange={onFileDropItemMenos}/>
                                            Selecionar Arquivo
                                        </button>
                                    }

                                    {fileItemMenos &&
                                        <div className="flex flex-row border-[2px] text-center w-48 justify-between items-center border-soulog-900 text-soulog-900 text-sm font-semibold rounded-md mt-8 mb-2">
                                            <img src={FileText} alt="File Icon" className="my-2 w-6"/>
                                            <p className="font-bold text-xs">{fileNameItemMenos}</p>
                                            <button className="relative top-0 right-0" onClick={handleDeleteFileMenos}>
                                                <img src={X} alt="Close Icon" className="my-2 mr-2 w-4 rounded-full border-black border-solid border-2 "/>
                                            </button>
                                        </div>
                                    }
                                    
                                </div>                                
                            </div>
                        }

                        {itemAvariado && 
                            <div className="flex flex-row justify-center items-center my-3">
                                <div className="flex flex-col border-[2px] text-center justify-center items-center border-soulog-900 rounded-md w-52 h-42">
                                    <p className="font-semibold mt-2">XML Ressalva <br/>Itens Avariados</p>
                                    
                                    {!fileItemAvariado &&
                                        <button className="relative border-[2px] w-48 border-soulog-900 text-soulog-900 text-sm font-semibold rounded-md px-4 py-2 mt-8 mb-2">
                                            <input type="file" accept="application/xml" className="absolute w-full h-full cursor-pointer top-0 left-0 opacity-0" value="" onChange={onFileDropItemAvariado}/>
                                            Selecionar Arquivo
                                        </button>
                                    }

                                    {fileItemAvariado &&
                                        <div className="flex flex-row border-[2px] text-center w-48 justify-between items-center border-soulog-900 text-soulog-900 text-sm font-semibold rounded-md mt-8 mb-2">
                                            <img src={FileText} alt="File Icon" className="my-2 w-6"/>
                                            <p className="font-bold text-xs">{fileNameAvariado}</p>
                                            <button className="relative top-0 right-0" onClick={handleDeleteFileAvariado}>
                                                <img src={X} alt="Close Icon" className="my-2 mr-2 w-4 rounded-full border-black border-solid border-2 "/>
                                            </button>
                                        </div>
                                    }

                                </div>
                            </div>
                        }   
                        
                    </>
                </div>
                }

            {error &&
                <div className="xl:mt-5 w-full">
                    <span className="flex flex-col justify-center text-center bg-red-300 py-2 px-3 rounded-2">
                        {errorMsg}
                    </span>
                </div>
            }

            <div className="container flex justify-between mt-3 mb-8">
                <button
                    className={`bg-white border-2 border-soulog-900 text-soulog-900 text-sm 
                    font-semibold rounded-md px-5 py-2 `}
                    onClick={() => setRessalvaModal(null)}
                    >
                    Voltar
                </button>

                <button
                    className="bg-soulog-900 border-2 border-soulog-900 text-white text-sm font-semibold rounded-md px-5 py-2"
                    onClick={ handleClickSave }
                    disabled={ loading }
                >
                    {loading &&
                        <svg role="status" class="inline mr-3 w-4 h-4 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                        </svg>
                    }   

                    Aceitar Ressalvas
                    
                </button>
            </div>
        </div>
        
    )
}